var map = {
	"./cosmic/vs.js": 32,
	"./matrix/vs.js": 7995,
	"./morning/vs.js": 9532,
	"./neon/vs.js": 9631,
	"./sky/vs.js": 7903,
	"./sunset/vs.js": 8588
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8155;
module.exports = webpackAsyncContext;